module.exports = __webpack_public_path__ + "img/profile.ab0e36cb.jpg";